import { C1Dialog, C1DialogContent, C1DialogTitle } from 'components/core/dialog/C1Dialog'
import { APIError } from 'components/core/errors/api'
import { periods } from 'components/core/time/duration'
import { ClosableProps } from 'components/no-ui/context/modal-provider'
import { RequestAccessFormV2 } from 'components/pages/accessrequest/create/form-v2/RequestAccessFormV2'
import { AppValue } from 'lib/actions/apps'
import { AppEntitlementValue } from 'lib/actions/apps/app-entitlement'
import { AppUserValue } from 'lib/actions/apps/app-users'
import { UserValue } from 'lib/actions/user'
import { GetAppRequest } from 'pbts/c1/api/app/v1/app'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { appGetApi } from 'redux_toolkit/apps'

type RequestAccessFormV2DialogProps = {
    entitlements: AppEntitlementValue[]
    user: UserValue
    appUser?: AppUserValue
} & ClosableProps

const RequestAccessFormV2Dialog: FC<RequestAccessFormV2DialogProps> = ({
    entitlements,
    user,
    appUser,
    close,
}) => {
    const { data: app, isError: appIsError, error: appError } = appGetApi.useGet(
        GetAppRequest.create({
            id: entitlements[0].appId,
        }),
        { notify: true },
    )

    if (entitlements.length === 0) {
        return null
    }

    return <C1Dialog open onClose={close} maxWidth="sm" fullWidth>
        <C1DialogTitle>
            <FormattedMessage id="request_access_dialog_header" defaultMessage="Request access" />
        </C1DialogTitle>
        <C1DialogContent>
            {appIsError && <APIError err={appError} />}
            {app && <RequestAccessFormV2
                showCopyLink={false}
                onSubmitCallback={close}
                onCancel={close}
                variant="dialog"
                defaultValues={{
                    user,
                    ents: entitlements,
                    appUser: appUser || null as unknown as AppUserValue,
                    app: app as AppValue || null,
                    provisionDurationSeconds: periods.INDEF,
                    access: 'general',
                    emergencyAccess: false,
                    justification: '',
                }}
            />}
        </C1DialogContent>
    </C1Dialog>
}

export default RequestAccessFormV2Dialog
